export const retrieveMergeResponseGlobalVarsCase = (
  isGlobalValuesConsider: boolean,
  payload: any,
  globalVariables?: any
) => {
  return isGlobalValuesConsider ? { ...payload, ...globalVariables } : { ...payload };
}
